import { render, staticRenderFns } from "./UsuarioFornecedorDadosPessoaisForm.vue?vue&type=template&id=5ee35cd7&scoped=true&lang=html"
import script from "./UsuarioFornecedorDadosPessoaisForm.vue?vue&type=script&lang=js"
export * from "./UsuarioFornecedorDadosPessoaisForm.vue?vue&type=script&lang=js"
import style0 from "./UsuarioFornecedorDadosPessoaisForm.vue?vue&type=style&index=0&id=5ee35cd7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee35cd7",
  null
  
)

export default component.exports